// eslint-disable-next-line import/prefer-default-export
const pinType = {
  ElectornicSignaturePin: 1,
  NoEmailConfirmationPin: 2
};

export default pinType;
